import { combineReducers } from 'redux';
import waitingReducer from './waitingReducer';
import errorReducer from './errorReducer';

export default combineReducers({
	error: errorReducer,
	waiting: waitingReducer
});
